module.exports = __webpack_public_path__ + "static/media/404-img.fecdeeb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/misc/404-img.png
// module id = 1025
// module chunks = 0